import ContentType from '@/helpers/contentType';
import CategoryType from '@/helpers/contentCategory';
import { TemplateName } from '@/helpers/templateType';
import WebConferenceProvider from '@/helpers/webconferenceProvider';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';

export default {
  props: {
    disableDynamicThemes: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      TemplateName,
      oldHtml           : '',
      oldExpectedAnswer : '',
      oldInstructions   : '',
      persistedHasGrade : false,
      isLoading         : false
    };
  },
  watch: {
    'topic.title': function(newValue) {
      this.topic.title = newValue;
    }
  },
  computed: {
    ...mapGetters({
      getterCourse          : 'plataforma/newContent/getterCourse',
      getterContent         : 'plataforma/newContent/getterContent',
      getterUserRoleContext : 'plataforma/user/getterUserContext'
    }),
    ...mapState({
      iesAlias    : state => state._core.tenant.iesAlias,
      tenantAlias : state => state._core.tenant.alias,
      backupValue : state => _.cloneDeep(state.plataforma.newContent.backupValue)
    }),
    templateName() {
      return this.$route.params.id ? this.getterContent.context?.templateName : this.getterCourse.context?.templateName;
    },
    currentTheme() {
      if (this.disableDynamicThemes) {
        return 'theme--plataforma-white';
      }

      return (
        {
          timeline  : 'theme--plataforma-white',
          streaming : 'theme--plataforma-black'
        }[this.templateName] || 'theme--plataforma-white'
      );
    },
    isDark() {
      return this.currentTheme === 'theme--plataforma-black';
    },
    dialogModalOverlayColor() {
      return {
        streaming: '#000000'
      }[this.templateName];
    },
    dialogModalOverlayOpacity() {
      return {
        streaming: 0.8
      }[this.templateName];
    },
    getGradeValue() {
      if (!this.topic) {
        return null;
      }

      return this.topic.grade?.value ? this.topic.grade.value : this.topic.grade;
    },
    isStreaming() {
      return this.templateName === this.TemplateName.STREAMING;
    }
  },
  methods: {
    ...mapActions({
      actionPatchIsVisibleTopic : 'plataforma/newContent/actionPatchIsVisibleTopic',
      actionUploadFile          : 'plataforma/upload/actionUploadFile',
      actionSaveNewTopic        : 'plataforma/newContent/actionSaveNewTopic',
      actionUpdateTopic         : 'plataforma/newContent/actionUpdateTopic',
      getGradeCategories        : 'plataforma/grades/getGradeCategories'
    }),
    ...mapMutations({
      SET_BACKUP_VALUE     : 'plataforma/newContent/SET_BACKUP_VALUE',
      SET_TOPIC_VERSION_AT : 'plataforma/newContent/SET_TOPIC_VERSION_AT'
    }),
    getInitialTextColor() {
      let theme;

      if (this.$route.params.id) {
        theme = this.$store.state.plataforma.newContent.content.context.templateName;
      } else {
        theme = this.$store.state.plataforma.newContent.course.context.templateName;
      }

      return (
        {
          timeline  : '#000000',
          streaming : '#FFFFFF'
        }[theme] || '#000000'
      );
    },
    hideAndShowTopic(topic) {
      const ungroupedTopic = !topic.parentTopicId && !topic.children && this.isStreaming;

      if (ungroupedTopic) {
        return this.$toast.error(this.$t('content.errorMessagesSnackbar.ungroupedTopicErrorMessage'));
      }
      const params = {
        topic,
        academicMainId : this.$route.params.courseId,
        version        : this.$route.params.id ? this.getterContent.context.version : this.getterCourse.context.version
      };

      this.$nuxt.$loading.start();

      this.actionPatchIsVisibleTopic(params)
        .then(() => {
          this.SET_TOPIC_VERSION_AT({ topicId: topic.id });
          this.$toast.success(this.$t('content.successMessagesSnackbar.changeVisibility'));
        })
        .catch(err => {
          this.$toast.error(err.data.error.message);
        })
        .finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    percentage(partialValue, totalValue) {
      return (100 * partialValue) / totalValue;
    },
    getTopicGrade(grade, topicId) {
      if (typeof grade === 'object') {
        if (grade.gradeBookDetails) {
          return grade.gradeBookDetails.activity.items?.find(item => item.topicId === topicId)?.weight || 0;
        }

        return grade.value;
      }

      return grade;
    },
    handleResetHtmlEditor() {
      if (this.topic.content.html) {
        this.topic.content.html = this.oldHtml;
      }
      if (this.topic.content.expectedAnswer) {
        this.topic.content.expectedAnswer = this.oldExpectedAnswer;
      }
      if (this.topic.content.instructions) {
        this.topic.content.instructions = this.oldInstructions;
      }
    },
    includeDefaultColor() {
      const defaultColor = this.getterCourse.context
        ? this.getterCourse.context.defaultCourseColor
        : this.getterContent.context.defaultCourseColor;
      if (this.editorSettings) {
        this.editorSettings.defaultColor = defaultColor || null;
      }
      if (!defaultColor || !this.topic?.design) {
        return;
      }
      if (this.topic.design.hasOwnProperty('innerContentDetailsColor')) {
        this.topic.design.innerContentDetailsColor =
          defaultColor || this.$store.state._core.application.themes.light.primary;
      }
      this.topic.design.cardDetailsColor = defaultColor || this.$store.state._core.application.themes.light.primary;
      this.topic.design.titleDetailsColor = defaultColor || this.$store.state._core.application.themes.light.primary;
    },
    handleOpenContentTypeModal(params, contentConfigurationsCallbackFunction = null) {
      this.academicMainId = params.academicMainId;
      this.academicMainTypeId = params.academicMainTypeId;
      this.version = params.version;

      this.includeDefaultColor();
      this.configFields.push('conditionalAvailability');

      if (params?.isEditing) {
        this.$nuxt.$loading.start();

        const requestParams = {
          academicMainId : params.academicMainId,
          topicId        : params.topicId
        };

        this.actionGetConfigurationsByTopicId(requestParams)
          .then(result => {
            this.topic = result;

            this.oldHtml = result.content && result.content.html;
            this.oldExpectedAnswer = result.content && result.content.expectedAnswer;
            this.oldInstructions = result.content && result.content.instructions;

            if (this.topic.design.titleDetailsColor === 'var(--v-primary-base)') {
              this.topic.design.titleDetailsColor = this.$store.state._core.application.themes.light.primary;
            }

            if (this.topic.design.bannerDetailsColor === 'var(--v-primary-base)') {
              this.topic.design.bannerDetailsColor = this.$store.state._core.application.themes.light.primary;
            }

            contentConfigurationsCallbackFunction && contentConfigurationsCallbackFunction(result);

            const isInsidePage = ContentType.isInsidePage(result.parentTopicId, result.parentTopicTypeId);
            if (isInsidePage && this.topic.hasGrade && this.topic.grade?.gradeBookDetails) {
              this.configFields.push('gradeComposition');
            } else if (ContentType.isActivityContent(this.topic.topicTypeId)) {
              this.configFields.push('grade');
            }

            if (
              !isInsidePage &&
              (this.topic.categoryTypeId === CategoryType.HTML ||
                this.topic.categoryTypeId === CategoryType.DISCURSIVE_EXERCISE ||
                this.topic.categoryTypeId === CategoryType.EXERCISE ||
                this.topic.categoryTypeId === CategoryType.LINKS)
            ) {
              this.designFields.push('card');
            }

            if (params?.isParentRecordingProgress) {
              this.blockedFields.push('recordProgress', 'progressType');

              this.topic.isRecordProgress = true;
            }

            this.isOpen = true;

            this.SET_BACKUP_VALUE(JSON.parse(JSON.stringify(this.topic)));
          })
          .catch(error => {
            this.$toast.error(error.message);
          })
          .finally(() => {
            this.$nuxt.$loading.finish();
          });
      } else {
        this.topic = {
          ...this.topic,
          ...params?.topic,
          ...{ parentTopicId: params?.parentTopicId || null, parentTopicTypeId: params?.contextTopicTypeId || null }
        };

        const isInsidePage = ContentType.isInsidePage(params.parentTopicId, params.contextTopicTypeId);

        if (isInsidePage) {
          const requestParams = {
            academicMainId : params.academicMainId,
            topicId        : params.parentTopicId
          };

          this.actionGetConfigurationsByTopicId(requestParams)
            .then(result => {
              this.topic.hasGrade = result.hasGrade;

              if (result.hasDeadline) {
                this.topic.parentTopicDeadlineAt = result.deadlineAt;
                this.topic.parentTopicHasDeadline = true;
                this.topic.hasDeadline = true;
                this.topic.deadlineAt = result.deadlineAt;
              }

              if (this.topic.hasGrade) {
                this.topic.grade = result.grade;
                this.configFields.push('gradeComposition');
              } else if (ContentType.isActivityContent(this.topic.topicTypeId)) {
                this.configFields.push('grade');
              }

              contentConfigurationsCallbackFunction && contentConfigurationsCallbackFunction();

              if (params?.isParentRecordingProgress) {
                this.blockedFields.push('recordProgress', 'progressType');

                this.topic.isRecordProgress = true;
                if (this.topic.categoryTypeId !== CategoryType.SCORM) {
                  this.topic.progressTypeId = result.progressTypeId;
                }
              }

              this.isOpen = true;

              this.SET_BACKUP_VALUE(JSON.parse(JSON.stringify(this.topic)));
            })
            .catch(error => {
              this.$toast.error(error.message);
            })
            .finally(() => {
              this.$nuxt.$loading.finish();
            });
        } else if (this.topic.topicTypeId === ContentType.PAGE) {
          contentConfigurationsCallbackFunction && contentConfigurationsCallbackFunction();

          this.isOpen = true;

          this.SET_BACKUP_VALUE(JSON.parse(JSON.stringify(this.topic)));
        } else {
          ContentType.isActivityContent(this.topic.topicTypeId) && this.configFields.push('grade');
          contentConfigurationsCallbackFunction && contentConfigurationsCallbackFunction();
          this.topic.isRecordProgress = true;

          if (
            this.topic.categoryTypeId === CategoryType.HTML ||
            this.topic.categoryTypeId === CategoryType.DISCURSIVE_EXERCISE ||
            this.topic.categoryTypeId === CategoryType.EXERCISE ||
            this.topic.categoryTypeId === CategoryType.LINKS
          ) {
            this.designFields.push('card');
          }

          this.isOpen = true;

          this.SET_BACKUP_VALUE(JSON.parse(JSON.stringify(this.topic)));
        }
      }
    },
    uploadFile(file) {
      const params = {
        file        : file,
        tenantAlias : this.tenantAlias,
        iesAlias    : this.iesAlias,
        courseId    : this.$route.params.id ? this.getterContent.context.contentId : this.getterCourse.context.contentId
      };

      this.isLoading = true;

      return this.actionUploadFile(params)
        .then(result => {
          return result;
        })
        .catch(err => {
          this.isLoading = false;
          return err;
        });
    },
    saveNewContent(data, allowErrorPropagation = false) {
      this.isLoading = true;

      if (this.topic.hasConditional && !this.topic.conditionals?.length) {
        this.isLoading = false;
        this.$nuxt.$loading.finish();
        return this.$toast.error(
          this.$t('content.layout.timeline.modalsContentType.common.editContent.conditionalsRequired')
        );
      }

      return this.actionSaveNewTopic(data)
        .then(response => {
          this.isLoading = false;
          this.version = response.version;
          this.topic.conditionalSetId = response.conditionalSetId;
          this.topic.conditionals = response.conditionals;
          this.topic.hasConditional = response.hasConditional;
          this.topic.id = response.id;
          this.persistedHasGrade = !!response.hasGrade;

          if (this.topic.topicTypeId !== ContentType.PAGE && this.topic.hasGrade) {
            this.topic.grade = { ...this.topic.grade, ...response.grade };
          }

          this.$toast.success(
            this.topic.topicTypeId === ContentType.AVALIA
              ? this.$t(
                'content.layout.timeline.modalsContentType.common.editContent.createExternalActivitySuccessMessage'
              )
              : this.$t('content.layout.timeline.modalsContentType.common.editContent.createSuccessMessage')
          );
          this.$nuxt.$loading.finish();
          this.validateGetCategories();
          this.SET_BACKUP_VALUE(JSON.parse(JSON.stringify(this.topic)));
          return response;
        })
        .catch(error => {
          this.isLoading = false;
          this.$toast.error(error.message);
          this.$nuxt.$loading.finish();

          if (allowErrorPropagation) {
            throw error;
          }
        });
    },

    updateContent(data, allowErrorPropagation = false) {
      this.isLoading = true;
      return this.actionUpdateTopic(data)
        .then(response => {
          if (this.$refs.contentTypeManagement && this.$refs.contentTypeManagement.$refs.generalConfigurations) {
            if (this.topic.categoryTypeId === CategoryType.EXERCISE || this.topic.categoryTypeId === CategoryType.DISCURSIVE_EXERCISE) {
              this.$refs.contentTypeManagement.$refs.generalConfigurations.originalContentHasRetries = response.content.hasRetries;
              this.$refs.contentTypeManagement.$refs.generalConfigurations.originalContentNumberRetries = response.content.numberRetries;
            }
          }

          this.version = response.version;
          this.topic.conditionalSetId = response.conditionalSetId;
          this.topic.conditionals = response.conditionals;
          this.topic.hasConditional = response.hasConditional;

          if (this.topic.topicTypeId === ContentType.PAGE && !this.topic.hasGrade && !this.topic.children.length) {
            this.topic.grade = {
              topicId                     : this.topic.id,
              name                        : this.topic.title,
              integratorCode              : null,
              value                       : 100,
              gradeBookId                 : null,
              gradeCategoryId             : null,
              gradeCategoryAcademicMainId : null,
              gradeBookDetails            : {
                activity: {
                  weight : 0,
                  items  : []
                },
                participation: {
                  weight : 0,
                  items  : []
                }
              }
            };
          } else if (this.topic.hasGrade) {
            this.topic.grade = response.grade;
          }

          if (this.topic.categoryTypeId === CategoryType.LINKS) {
            this.topic.content = response.content;
          }

          this.isLoading = false;
          this.$toast.success(
            this.topic.categoryTypeId === CategoryType.AVALIA
              ? this.$t(
                'content.layout.timeline.modalsContentType.common.editContent.updateExternalActivitySuccessMessage'
              )
              : this.$t('content.layout.timeline.modalsContentType.common.editContent.updateSuccessMessage')
          );
          this.$nuxt.$loading.finish();
          this.validateGetCategories();
          this.SET_BACKUP_VALUE(JSON.parse(JSON.stringify(this.topic)));
          return response;
        })
        .catch(error => {
          this.isLoading = false;
          this.$toast.error(error.message);
          this.$nuxt.$loading.finish();

          if (allowErrorPropagation) {
            throw error;
          }
        });
    },
    validateGetCategories() {
      if (this.backupValue.hasGrade !== this.topic.hasGrade) {
        this.loadCategories();
      }
    },
    loadCategories() {
      this.getGradeCategories({ courseId: this.$route.params.courseId }).catch(err => {
        this.$toast.error(err.data.error.message);
      });
    },
    hasWebConferenceProviderWithRecordings(topic) {
      return (
        topic.categoryTypeId === CategoryType.WEBCONFERENCE &&
        topic.content.provider.id === WebConferenceProvider.BLACKBOARD_COLLABORATE
      );
    }
  }
};
